import * as motion from "motion/react-client";
import React from "react";

interface ToggleProps {
    value: boolean;
    onChange: (next: boolean) => void;
}

const ToggleButton = ({ value, onChange }: ToggleProps) => {
    return (<>
        <button
            onClick={() => onChange(!value)}
            className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors ${
                value ? "bg-green-600" : "bg-gray-400"
            }`}
            style={{ maxWidth: "44px" }}
            aria-pressed={value}
        >
            <motion.span
                layout
                transition={{
                    type: "spring",
                    stiffness: 0,
                    damping: 0,
                }}
                className="absolute left-0 top-0 h-6 w-6 rounded-full bg-white shadow-md"
                style={{
                    x: value ? 20 : 0, // sliding distance
                }}
            />
        </button>
    </>);
}

export default ToggleButton;